import React, { useState, useRef } from "react";
import EnhancedTable from "../../Global/Table";
import RemoveRedEye from "@mui/icons-material/RemoveRedEye";

import { Box, Button, Grid, Typography, alpha } from "@mui/material";
import Download from "@mui/icons-material/Download";
import BaseModal from "../../Global/Modal";
import { useEffect } from "react";
import * as entity from "./Entity";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFiles from "../../Upload/upload-files.component";
import { useTranslation } from "react-i18next";
import jwtInterceptor from "../../../services/interceptors";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
const API_URL = process.env.REACT_APP_API_PROFILE_SERVICE_URL + "/api/";

const styles = {
  topContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "@media (max-width: 850px)": {
      flexDirection: "column",
      gap: "15px",
    },
  },
  optionsContainer: {
    display: "flex",
    gap: "15px",
  },
};

export const SelectCatStyle = (theme) => ({
  padding: "8px 10px",
  background: theme.palette.background.lightBack,
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: "40px",
  color: theme.palette.primary.main,
});

function createData(employeeId, employeeFullName, month, year, Action) {
  return {
    employeeId,
    employeeFullName,
    //title,
    month,
    year,
    Action,
  };
}
function createFaultData(employeeId, fileName, reason, Action) {
  return {
    employeeId,
    fileName,
    reason,
    Action,
  };
}
function CellAction({ id, filename, onDelete }) {
  const { t } = useTranslation();
  return (
    <Box className="action-icon-rounded">
      <Button
        onClick={() => {
          handleDownload(id, filename);
        }}
        title={t("Download Payslip")}
        sx={{
          backgroundColor: alpha("#18A0FB", 0.1),
          svg: {
            fill: "#18A0FB",
          },
        }}
      >
        <Download />
      </Button>
      <Button
        onClick={() => {
          handleView(id, filename);
        }}
        title={t("View Payslip")}
        sx={{
          backgroundColor: alpha("#27AE60", 0.1),
          svg: {
            fill: "#27AE60",
          },
        }}
      >
        <RemoveRedEye />
      </Button>
      <Button
        sx={{
          backgroundColor: alpha("#DF6F79", 0.1),

          svg: {
            fill: "#DF6F79",
          },
        }}
        title={t("Delete Payslip")}
        onClick={() => {
          onDelete(id);
        }}
      >
        <DeleteIcon />
      </Button>
    </Box>
  );
}

function CellFaultAction({ id, filename, onDelete }) {
  const { t } = useTranslation();
  return (
    <Box className="action-icon-rounded">
      <Button
        onClick={() => {
          handleFaultDownload(id, filename);
        }}
        title={t("Download Payslip")}
        sx={{
          backgroundColor: alpha("#18A0FB", 0.1),
          svg: {
            fill: "#18A0FB",
          },
        }}
      >
        <Download />
      </Button>
      <Button
        onClick={() => {
          handleFaultView(id, filename);
        }}
        title={t("View Payslip")}
        sx={{
          backgroundColor: alpha("#27AE60", 0.1),
          svg: {
            fill: "#27AE60",
          },
        }}
      >
        <RemoveRedEye />
      </Button>
      <Button
        sx={{
          backgroundColor: alpha("#DF6F79", 0.1),

          svg: {
            fill: "#DF6F79",
          },
        }}
        title={t("Delete Payslip")}
        onClick={() => {
          onDelete(id);
        }}
      >
        <DeleteIcon />
      </Button>
    </Box>
  );
}
const handleView = async (id, filename) => {
  const email = sessionStorage.getItem("email_key");
  let url = API_URL + "Payslip/OpenPayslip?id=" + id + "&email=" + email;
  window.open(url, "_blank");
};
const handleDownload = async (id, filename) => {
  const email = sessionStorage.getItem("email_key");
  let url = API_URL + "Payslip/DownloadPayslip?id=" + id + "&email=" + email;
  console.log(url);
  fetch(url, {
    method: "Get",
    headers: { "Content-Type": "application/pdf" },
  })
    .then((response) => response.blob())
    .then((response) => {
      // create "a" HTML element with href to file & click
      const href = URL.createObjectURL(response);
      console.log(href);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
};
const handleFaultView = async (id, filename) => {
  const email = sessionStorage.getItem("email_key");
  let url = API_URL + "Payslip/OpenFaultPayslip?id=" + id + "&email=" + email;
  window.open(url, "_blank");
};
const handleFaultDownload = async (id, filename) => {
  const email = sessionStorage.getItem("email_key");
  let url =
    API_URL + "Payslip/DownloadFaultPayslip?id=" + id + "&email=" + email;
  console.log(url);
  fetch(url, {
    method: "Get",
    headers: { "Content-Type": "application/pdf" },
  })
    .then((response) => response.blob())
    .then((response) => {
      // create "a" HTML element with href to file & click
      const href = URL.createObjectURL(response);
      console.log(href);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
};
function EmployeeSkillsTable(props) {
  const [open, setOpen] = useState(false);
  const [addButton, setaddButton] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteFaultModal, setDeleteFaultModal] = useState(false);
  const [selectedpayslip, setSelectedPayslip] = useState(0);
  const [payslips, setPayslips] = useState([]);
  const [faultPayslips, setFaultPayslips] = useState([]);

  const [files, setFiles] = useState([]);
  const initialized = useRef(false);
  const [subMenu, setSubMenu] = useState("success");

  const [loading, setLoading] = useState(false);

  const tblRows = [];
  const handleDelete = async () => {
    let url = "api/Payslip/DeletePayslip?id=" + selectedpayslip;
    //let response = await payslipService.deletePayslip(url);

    jwtInterceptor.delete(url).then((response) => {
      fetchPayloads();
    });
    setDeleteModal(false);
  };

  const handleFaultDelete = async () => {
    let url = "api/Payslip/DeletefaultPayslip?id=" + selectedpayslip;
    //let response = await payslipService.deletePayslip(url);

    jwtInterceptor.delete(url).then((response) => {
      getFaultPayslips();
    });
    setDeleteFaultModal(false);
  };

  const fetchPayloads = async () => {
    let url = "api/Payslip/GetPayslips";

    setLoading(true);
    if (props.empid) {
      setaddButton(false);
      url = "api/Payslip/GetPayslip?id=" + props.empid;
      console.log(url);
    }
    //let response = await payslipService.getPayslips(url);

    jwtInterceptor
      .get(url)
      .then((response) => {
        for (var x of response.data) {
          const filename =
            x.employeeId + "-" + x.month + "-" + x.year + x.filepath;
          tblRows.push(
            createData(
              x.employeeId,
              x.employeeName,
              //x.title,
              x.month,
              x.year,
              <CellAction
                id={x.payslipId}
                filename={filename}
                onDelete={(id) => {
                  setSelectedPayslip(id);
                  setDeleteModal(true);
                }}
              />
            )
          );
        }
        setPayslips(tblRows);
      })
      .catch((e) => {})
      .finally((e) => {
        setLoading(false);
      });
  };

  const getFaultPayslips = async () => {
    let url = "api/Payslip/GetFaultPayslips";

    setLoading(true);

    jwtInterceptor
      .get(url)
      .then((response) => {
        let tblRows = [];
        for (var x of response.data) {
          tblRows.push(
            createFaultData(
              x.employeeId,
              x.filepath,
              x.reason,
              <CellFaultAction
                id={x.employeeId}
                filename={x.filepath}
                onDelete={(id) => {
                  setSelectedPayslip(id);
                  setDeleteFaultModal(true);
                }}
              />
            )
          );
        }
        setFaultPayslips(tblRows);
      })
      .catch((e) => {})
      .finally((e) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetchPayloads();
      getFaultPayslips();
    }
  }, []);

  const { t } = useTranslation();

  return (
    <>
      <Box sx={styles.topContainer}>
        {props?.role === "admin" ? (
          <Box sx={styles.optionsContainer}>
            <Box
              className="c-l"
              sx={(theme) => ({
                cursor: "pointer",
                display: "flex",
                alignContent: "center",

                ...(subMenu === "success" && SelectCatStyle(theme)),
              })}
              onClick={() => setSubMenu("success")}
            >
              <CheckCircleOutlineIcon />
              <Typography variant="smallBody">{t("Succeed")}</Typography>
            </Box>
            <Box
              className="c-l"
              sx={(theme) => ({
                cursor: "pointer",
                display: "flex",
                alignContent: "center",

                ...(subMenu === "failed" && SelectCatStyle(theme)),
              })}
              onClick={() => setSubMenu("failed")}
            >
              <HighlightOffIcon />
              <Typography variant="smallBody">{t("Failed")}</Typography>
            </Box>
          </Box>
        ) : null}
      </Box>

      {subMenu === "success" ? (
        <EnhancedTable
          title="Employees Payslips"
          head={entity.headCells}
          rows={payslips}
          onAddClick={() => setOpen((pre) => !pre)}
          isAddable={addButton}
          loading={loading}
        />
      ) : (
        <EnhancedTable
          head={entity.faultheadCells}
          rows={faultPayslips}
          loading={loading}
        />
      )}
      <BaseModal
        open={open}
        handleClose={() => setOpen((pre) => !pre)}
        title="Upload new payslips"
        showSaveButton={false}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <UploadFiles path="Payslip/UploadPayslip" t={t} />
          </Grid>
        </Grid>
      </BaseModal>
      <BaseModal
        open={deleteModal}
        handleClose={() => setDeleteModal((pre) => !pre)}
        title="Delete payslip"
        yesOrNo={true}
        onSave={() => handleDelete()}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="SmallBody">
              {t("Do you want to delete the selected payslip ?")}
            </Typography>
          </Grid>
        </Grid>
      </BaseModal>
      <BaseModal
        open={deleteFaultModal}
        handleClose={() => setDeleteFaultModal((pre) => !pre)}
        title="Delete payslip"
        yesOrNo={true}
        onSave={() => handleFaultDelete()}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="SmallBody">
              {t("Do you want to delete the selected Faultpayslip ?")}
            </Typography>
          </Grid>
        </Grid>
      </BaseModal>
    </>
  );
}

export default EmployeeSkillsTable;
